import styled from "styled-components";
import colours from "../constants/colours";

const ErrorMessage = styled.span`
  color: ${colours.red};
  display: block;
`;

export default ErrorMessage;
